const cards = [
  {
    id: 1,
    tag: '独家',
    tagBg: 'bg-primary-100 text-primary-700',
    title: '某女星海外秘密生子细节曝光，孩子生父身份成最大谜团',
    desc: '知情人士独家透露该女星过去一年的行程轨迹，多张照片证据浮出水面。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20editorial%20visual%20with%20warm%20coral%20red%20gradients%2C%20celebrity%20gossip%20magazine%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20geometric%20shapes%2C%20luxurious%20composition%2C%20no%20text&width=800&height=500&seq=card-1-chigua&orientation=landscape',
  },
  {
    id: 2,
    tag: '追踪',
    tagBg: 'bg-accent-100 text-accent-700',
    title: '某流量小生被品牌方集体取消代言，背后原因令人震惊',
    desc: '三天内七家品牌发布解约声明，行业人士分析或与近期即将公开的重大负面新闻有关。',
    image: 'https://readdy.ai/api/search-image?query=Breaking%20news%20abstract%20visual%20with%20warm%20amber%20and%20cream%20tones%2C%20business%20scandal%20theme%2C%20dramatic%20geometric%20composition%2C%20editorial%20magazine%20style%2C%20bold%20contrast%2C%20no%20text&width=800&height=500&seq=card-2-chigua&orientation=landscape',
  },
  {
    id: 3,
    tag: '内幕',
    tagBg: 'bg-secondary-100 text-secondary-700',
    title: '某知名综艺导演私下收受选手贿赂，选秀结果均有内定',
    desc: '匿名工作人员提供大量聊天记录和转账凭证，涉事节目组高层已启动内部调查。',
    image: 'https://readdy.ai/api/search-image?query=Investigative%20abstract%20visual%20with%20warm%20red%20and%20charcoal%20tones%2C%20scandal%20theme%2C%20dark%20moody%20atmosphere%2C%20geometric%20layered%20composition%2C%20dramatic%20editorial%20style%2C%20no%20text&width=800&height=500&seq=card-3-chigua&orientation=landscape',
  },
  {
    id: 4,
    tag: '爆料',
    tagBg: 'bg-primary-100 text-primary-700',
    title: '娱乐圈真实片酬大公开：顶流一部戏报价已突破亿元大关',
    desc: '多份合同文件显示明星真实收入远超外界想象，税务总局或将出台新规加强监管。',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20abstract%20visual%20with%20warm%20golden%20and%20coral%20gradients%2C%20wealth%20and%20luxury%20theme%2C%20elegant%20geometric%20patterns%2C%20magazine%20feature%20style%2C%20dramatic%20lighting%2C%20no%20text&width=800&height=500&seq=card-4-chigua&orientation=landscape',
  },
  {
    id: 5,
    tag: '深度',
    tagBg: 'bg-accent-100 text-accent-700',
    title: '2025年网红行业大洗牌：抖音快手接连出手整顿直播生态',
    desc: '两大平台最新政策解读，中小网红面临生存危机，行业即将进入规范化发展阶段。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20platform%20abstract%20visual%20with%20warm%20coral%20and%20amber%20gradients%2C%20social%20media%20regulation%20theme%2C%20modern%20clean%20geometric%20shapes%2C%20editorial%20style%2C%20dramatic%20composition%2C%20no%20text&width=800&height=500&seq=card-5-chigua&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">热门专题</h2>
          <p className="text-foreground-500 text-sm">精选深度爆料内容，带你全面了解每一个瓜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {cards.map((card) => (
            <a
              key={card.id}
              href="#cards"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-2.5 py-0.5 rounded text-xs font-medium mb-3 ${card.tagBg}`}>
                  {card.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}